import { hideLoading, showLoading } from 'redux-store/reducers/loading-reducer';
import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';
import { logError } from 'utils/log';
import { Querystring } from 'utils/url';

const RECEIVE = 'influencerProfile/RECEIVE';
const RESET = 'influencerProfile/RESET';

const { getInfluencersMetricsData } = API.END_POINTS.INFLUENCERS;

const initialState = {
  data: {}
};

function receiveInfluencersMeta(data) {
  return {
    type: RECEIVE,
    payload: {
      data
    }
  };
}

export function resetInfluencersMeta() {
  return (dispatch) => {
    dispatch({
      type: RESET
    });
  };
}

export function fetchInfluncerMetrics(campaignId?: number, influencerIds?: Array<string | number>, skipGlobalLoading?: boolean) {
  const params = {
    channel_types: ['INSTAGRAM', 'TIKTOK', 'YOUTUBE']
  } as {
    campaign_id?: number,
    influencer_ids?: Array<string | number>,
    channel_types: Array<string>
  };

  if (campaignId) {
    params.campaign_id = campaignId;
  } else if (influencerIds?.length) {
    params.influencer_ids = influencerIds;
  }

  const queryParam = Querystring.objectToString(params);

  return (dispatch) => {
    const url = `${getInfluencersMetricsData()}?${queryParam}`;

    if (!skipGlobalLoading) {
      dispatch(showLoading(url));
    }

    return get(url)
      .then((response) => {
        const influencersMetrics = response.data;

        dispatch(hideLoading(url));
        dispatch(receiveInfluencersMeta(influencersMetrics));
      })
      .catch((error) => {
        logError(error);

        if (!skipGlobalLoading) {
          dispatch(hideLoading(url));
        }

        throw error;
      });
  };
}

export default createReducer<any, any>('influencersMetrics', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [RESET]: () => initialState,
  [RECEIVE]: (state, { data }) => ({
    ...state,
    data: { ...state.data, ...data }
  })
});
